__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "fp_portal_app";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@emotion/react", "11.10.6", () => (() => (__webpack_require__(50328))), 1);
			register("@emotion/styled", "11.10.6", () => (() => (__webpack_require__(40280))), 1);
			register("@mui/material", "6.1.2", () => (() => (__webpack_require__(39135))), 1);
			register("@mui/x-date-pickers-pro", "7.23.6", () => (() => (__webpack_require__(52933))), 1);
			register("@mui/x-date-pickers", "7.23.6", () => (() => (__webpack_require__(10452))), 1);
			register("axios", "1.13.2", () => (() => (__webpack_require__(80687))), 1);
			register("axios", "1.3.4", () => (() => (__webpack_require__(87951))), 1);
			register("react-dom", "18.2.0", () => (() => (__webpack_require__(97950))), 1);
			register("react-toastify", "10.0.6", () => (() => (__webpack_require__(91036))), 1);
			register("react", "18.2.0", () => (() => (__webpack_require__(65043))), 1);
			register("styled-components", "5.3.9", () => (() => (__webpack_require__(72119))), 1);
			initExternal(32191);
			initExternal(3315);
			initExternal(21043);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};